import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from 'app/components/header/header.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import {
    ActivatedRoute,
    NavigationStart,
    Router,
    RouterModule,
} from '@angular/router';
import { FormsModule } from '@angular/forms';
import { BubbleComponent } from './components/bubble/bubble.component';
import { FaqService } from './faq.service';
import { CommonModule } from '@angular/common';
import { SearchResultsComponent } from './components/search-results/search-results.component';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss'],
    imports: [
        CommonModule,
        MatIconModule,
        MatTabsModule,
        FormsModule,
        FooterComponent,
        HeaderComponent,
        TranslateModule,
        RouterModule,
        BubbleComponent,
        SearchResultsComponent,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
})
export class FaqComponent implements OnInit {
    searchKeyword: string = '';
    selectedLanguage: any;
    searchResults: any = [];
    sData: any = [];
    isSearched: boolean = false;
    faqsData: any = null;
    filteredData: any = null;
    selectedQuestions: any = [];
    selectedQuestionDetails: {} | null = null;
    filteredQuestions: any = [];
    showDetails: boolean = false;
    categoryNameEn: string = '';
    categoryNameBm: string = '';
    activeIndex: number = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private faqService: FaqService,
        private toastr: ToastrService,
    ) {}

    ngOnInit() {
        this.selectedLanguage = localStorage.getItem('language');
        this.faqService.getFaqs().subscribe((data: any) => {
            if (data.length > 0) {
                this.faqService.initializeSearch(data, [
                    'questionEn',
                    'questionBm',
                ]);
                this.faqsData = data;
                this.filteredData = data;
                this.setFAQsState();
            } else {
                this.toastr.error('Data not found!');
            }
        });

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                if (event.navigationTrigger === 'popstate') {
                    this.goBack();
                }
            }
        });
    }

    setFAQsState() {
        this.route.queryParams.subscribe((params) => {
            let query;
            query = params['q'];
            if (query) {
                this.searchContent(query);

                if (!(this.searchResults.length > 0)) {
                    this.goBack();
                } else {
                    this.isSearched = true;
                    this.categoryNameEn = 'Search Results';
                    this.categoryNameBm = 'Hasil Carian';
                    this.clearSearch();
                }
            }
        });
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    goToContactUs() {
        this.router.navigate(['/contact-us']);
        localStorage.setItem('miti-enq', 'true');
    }

    switchLanguageHandler(data: any) {
        this.selectedLanguage = data;
    }

    searchCategory(keyword: string) {
        keyword = keyword.toLowerCase();
        this.filteredData = this.faqsData.filter((faq: any) => {
            if (this.selectedLanguage == 'en') {
                if (faq.categoryEn.toLowerCase().includes(keyword)) {
                    return faq;
                }
            } else {
                if (faq.categoryBm.toLowerCase().includes(keyword)) {
                    return faq;
                }
            }
        });
    }

    searchContent(keyword: string) {
        const res = this.faqService.search(keyword);
        this.searchResults = res;
        if (this.searchResults.length > 0) {
            this.sData = this.searchResults;
        }
    }

    searchQuestion(item) {
        const title =
            this.selectedLanguage == 'en' ? item.categoryEn : item.categoryBm;
        const question =
            this.selectedLanguage == 'en' ? item.questionEn : item.questionBm;
        const slug = title
            .replaceAll(' ', '-')
            .replaceAll('?', '')
            .toLowerCase();
        const queSlug = question
            .replaceAll(' ', '-')
            .replaceAll('?', '')
            .toLowerCase();
        this.searchKeyword = '';
        this.router.navigate([`/faq/${slug}`], {
            queryParams: { q: queSlug },
        });
    }

    clearSearch() {
        this.searchKeyword = '';
    }

    setCat(item: any) {
        const title =
            this.selectedLanguage == 'en' ? item.categoryEn : item.categoryBm;
        const slug = title
            .replaceAll(' ', '-')
            .replaceAll('?', '')
            .toLowerCase();
        this.searchKeyword = '';
        this.router.navigate([`/faq/${slug}`]);
    }

    displaySearchResults() {
        this.router.navigate([], {
            queryParams: { q: this.searchKeyword },
            queryParamsHandling: 'merge',
        });
    }

    setQuestionDetails(q: string, index: number) {
        this.activeIndex = index;
        this.selectedQuestionDetails = q;
    }

    goBack() {
        this.activeIndex = 0;
        this.showDetails = false;
        this.isSearched = false;
        this.filteredData = this.faqsData;
        this.searchKeyword = '';
        this.router.navigate([], {
            queryParams: {},
        });
    }
}
